import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import Currency from '../../Currency';
import CirclesLoadingAnimation from '../../Loaders/CirclesLoadingAnimation';

import useStyles from './makeStyles';

const SelectedPlanPrices = ({ discountedPrice, price, isFetchingPrice }) => {
  const { t } = useTranslation();
  const selectedPlanDiscountedIsApply = discountedPrice ? discountedPrice.promoCodeApply : false;
  const classes = useStyles();

  if (
    isFetchingPrice && discountedPrice
    && discountedPrice.promoCode && isEmpty(discountedPrice.errorMessage)
  ) {
    return <CirclesLoadingAnimation />;
  }

  if (!selectedPlanDiscountedIsApply) {
    return <></>;
  }

  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item className={classes.priceContainer}>
        <Currency value={price} withSymbol />
      </Grid>
      {
        discountedPrice.price && (
        <Grid item className={classes.discountedPrice}>
          <Currency value={discountedPrice.price} withSymbol />
        </Grid>
        )
      }
      <Grid item className={classes.totalSaving}>
        (
        {t('promoCode.youSaved')}
        {' '}
        -
        {' '}
        <div className={classes.totalSavingPrice}>
          <Currency value={discountedPrice.totalSaving} withSymbol />
        </div>
        )
      </Grid>
    </Grid>
  );
};

SelectedPlanPrices.propTypes = {
  discountedPrice: PropTypes.shape({
    priceBeforeDiscount: PropTypes.number,
    price: PropTypes.number,
    promoCodeApply: PropTypes.bool,
    totalSaving: PropTypes.number,
    promoCode: PropTypes.string,
    errorMessage: PropTypes.shape({}),
  }),
  price: PropTypes.number,
  isFetchingPrice: PropTypes.bool,
};

SelectedPlanPrices.defaultProps = {
  price: null,
  isFetchingPrice: false,
  discountedPrice: {
    promoCode: '',
  },
};

export default SelectedPlanPrices;
